var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductImageSkeleton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3508 14.0169L15.7425 7.91689C15.2675 6.80022 14.5592 6.16689 13.7508 6.12522C12.9508 6.08355 12.1758 6.64189 11.5842 7.70855L10.0008 10.5502C9.66751 11.1502 9.19251 11.5086 8.67585 11.5502C8.15085 11.6002 7.62585 11.3252 7.20085 10.7836L7.01751 10.5502C6.42585 9.80855 5.69251 9.45022 4.94251 9.52522C4.19251 9.60022 3.55085 10.1169 3.12585 10.9586L1.68418 13.8336C1.16751 14.8752 1.21751 16.0836 1.82585 17.0669C2.43418 18.0502 3.49251 18.6419 4.65085 18.6419H15.2842C16.4008 18.6419 17.4425 18.0836 18.0592 17.1502C18.6925 16.2169 18.7925 15.0419 18.3508 14.0169Z",
    fill: "#C7C7D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80885 6.98294C7.36446 6.98294 8.62552 5.72188 8.62552 4.16628C8.62552 2.61067 7.36446 1.34961 5.80885 1.34961C4.25325 1.34961 2.99219 2.61067 2.99219 4.16628C2.99219 5.72188 4.25325 6.98294 5.80885 6.98294Z",
    fill: "#C7C7D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductImageSkeleton);
export default __webpack_public_path__ + "static/media/product-image-skeleton.d2109fbe64e9a227c46636d813a26370.svg";
export { ForwardRef as ReactComponent };